import React from 'react';
import './Loading.scss';

const className = 'c-Loading';

const Loading = () => <div className={className} />;

export default Loading;
